import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS } from 'utils/styles';

export const DashboardWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  background: ${COLORS.whiteLite};
  overflow: hidden;
`;

export const MainDashboard = styled.div`
  width: 100%;
  height: 100%;
  padding: 34px;
  background: ${COLORS.white};
`;

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${COLORS.multiSilver};
  overflow-y: hidden;
  z-index: 1000;
`;

export const ComponentTopBlock = styled.div`
  width: 100%;
  height: 164px;
`;

export const TitleAndAddButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 50px;
`;

export const SystemUsersAndCustomersSection = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  height: 47px;
  border-bottom: 1px solid ${COLORS.mainColor};
`;

export const SystemUsersAndCustomersButton = styled.button`
  width: 176px;
  height: 46px;
  background: ${({ activeTab }) =>
    activeTab ? COLORS.mainColor : COLORS.whiteLite};
  color: ${({ activeTab }) => (activeTab ? COLORS.whiteLite : COLORS.black)};
  ${FONTS.font18};
  ${FONT_FAMILY.FontRegular};
  border-radius: 8px 8px 0 0;
`;

export const TitleOfPage = styled.span`
  ${FONTS.font24};
  ${FONT_FAMILY.FontMedium};
  text-transform: capitalize;
  color: ${COLORS.black};
`;

export const AddButton = styled.button`
  width: 172px;
  height: 46px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font18};
  text-transform: capitalize;
  border-radius: 8px;
`;

export const AboutContentBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 50px;
`;

export const ShowQuantityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 200px;
  height: 100%;
`;

export const Select = styled.select`
  width: 80px;
  height: 32px;
  padding-inline: 10px;
  margin-right: 10px;
  outline: none;
  border: 1px solid ${COLORS.mainColor};
  border-radius: 8px;
  -webkit-appearance: none;
  ${FONTS.font16};
`;

export const DeleteAndSearchBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 432px;
  height: 32px;
`;

export const DeleteAllButton = styled.button`
  width: 128px;
  height: 32px;
  background: ${COLORS.mainColor};
  border: 1px solid ${COLORS.lightSilver};
  color: ${COLORS.white};
  ${FONTS.font16};
  ${FONT_FAMILY.FontRegular};
  border-radius: 8px;

  &:hover {
    background: transparent;
    color: ${COLORS.lightSilver};
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  border: 1px solid ${COLORS.lightSilver};
  border-radius: 8px;
  padding-right: 10px;
`;

export const SearchInput = styled.input`
  width: 270px;
  height: 32px;
  padding-left: 10px;
  padding-right: 2px;
  background: transparent;
  border: none;
`;

export const TableBlock = styled.table`
  margin-top: 20px;
  width: 100%;
  border-collapse: collapse;
`;

export const TableBody = styled.tbody``;

export const TableLine = styled.tr`
  border-bottom: 1px solid ${COLORS.lightSilver};
`;

export const TableElement = styled.td`
  height: 60px;
`;

export const TableSampleBlock = styled.div`
  display: flex;
  gap: 10px;
  width: ${({ title }) => title && '260px'};
`;

export const EditAndDeleteButton = styled.img`
  cursor: pointer;
`;

export const SearchIcon = styled.img`
  cursor: pointer;
`;
